import { render, staticRenderFns } from "./joinZoom.vue?vue&type=template&id=2cb355e2"
import script from "./joinZoom.vue?vue&type=script&lang=js"
export * from "./joinZoom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports